export const ESPACIOS_BASE_ROUTE = "/espacios";

export const ESPACIOS_ROUTES = {
  MENU: ESPACIOS_BASE_ROUTE,
  CONSULTAS_ESPACIOS_RESERVADOS: `${ESPACIOS_BASE_ROUTE}/consulta-espacios`,
  CONSULTAS_GENERAL_RESERVAS: `${ESPACIOS_BASE_ROUTE}/consulta-espacios-general`,
  RESERVA_ESPACIO: `${ESPACIOS_BASE_ROUTE}/reservas`,
  ESPACIOS: `${ESPACIOS_BASE_ROUTE}/espacios`,
};
